export const HeadCellSellsByUser = [
  { id: "option", disablePadding: false, label: "" },
  { id: "productType", disablePadding: false, label: "Tipo de producto" },
  { id: "detail", disablePadding: false, label: "Detalle" },
  {
    id: "productInfo",
    disablePadding: false,
    label: "Subcat/IMEI/ICCID/Pend.pago",
  },
  { id: "barCode", disablePadding: false, label: "Código de barras" },
  { id: "price", disablePadding: false, label: "Precio de venta" },
  { id: "discount", disablePadding: false, label: "Descuento" },
  {
    id: "payment",
    disablePadding: false,
    label: "Forma de pago / total Accs",
  },
  { id: "sellDate", disablePadding: false, label: "Fecha de venta" },
  { id: "billing", disablePadding: false, label: "Factura generada" },
];
